import { ReactComponent as FlagIcon } from "./svg/cn-flag.svg";
import "../flag-icon.scss";

export const CNFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
